import { Info } from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { Mortgage } from "../../../../../model/MortgageExtensionModel";
import { formatAmount } from "../../../../../utils/NumberUtils";
import MortgageTooltip from "../../../../tooltip/MortgageTooltip";
import { MortgageSummaryBold, MortgageSummaryLabel } from "../../../2-summary/NewMortgageSummary";

const MortgageTotalMobile = (props: { newMortgage?: Mortgage }) => {
    const { t } = useTranslation();
    const { newMortgage } = props;

    return (
        <Box padding={"16px 16px"}>
            <MortgageSummaryBold>
                {t("ConfigurationScreen.Total charge after mortgage extension (as of today)")}
            </MortgageSummaryBold>
            <MortgageSummaryLabel>{t("ConfigurationScreen.Excluding additional costs")}</MortgageSummaryLabel>

            <Box display={"flex"} sx={{ marginTop: "24px" }}>
                <Box flex={"50%"}>
                    <MortgageSummaryBold>
                        {t("General.Monthly charge")}
                        <MortgageTooltip title={t("General.This calculation is indicative and is based on...")}>
                            <Info
                                sx={{
                                    fontSize: "16px",
                                    color: "#0093D1",
                                    marginLeft: "4px",
                                    marginBottom: "1px",
                                }}
                            />
                        </MortgageTooltip>
                    </MortgageSummaryBold>
                    <MortgageSummaryLabel>{t("General.Total amount")}</MortgageSummaryLabel>
                </Box>
                <Box flex={"50%"} sx={{ textAlign: "right" }}>
                    <MortgageSummaryBold>
                        {newMortgage?.currency} {formatAmount(newMortgage?.totalSumLiabilitiesMonthly ?? 0)}
                    </MortgageSummaryBold>
                    <MortgageSummaryLabel>
                        {newMortgage?.currency} {formatAmount(newMortgage?.totalSumLiabilities ?? 0)}
                    </MortgageSummaryLabel>
                </Box>
            </Box>
        </Box>
    );
};
export default MortgageTotalMobile;
